import {
    FieldConfig,
    SmartMetadataCard,
} from '@common/components/MetadataCard';
import { useFormattedBoolean, useFormattedVolume } from '@common/hooks';
import { useSelectedCollection } from '@features/Collection/hooks';
import { CollectionTechnicalDetails } from '@features/Collection/types';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const TechnicalDetailsSection = () => {
    const { t } = useTranslation('collectionDetails');
    const {
        selectedCollection: { technicalDetails: metadata },
        isLoading,
    } = useSelectedCollection();

    const { formatVolume } = useFormattedVolume();
    const { formatBoolean } = useFormattedBoolean();

    const config: FieldConfig<CollectionTechnicalDetails>[] = useMemo(
        () => [
            { key: 'volume', formatter: (val) => formatVolume(val) },
            { key: 'assetCount' },
            { key: 'stl', formatter: (val) => formatBoolean(val) },
            {
                key: 'audioLanguages',
                formatter: (val) => val.join(', ').toUpperCase(),
            },
            { key: 'resolutions', formatter: (val) => val.join(', ') },
            { key: 'colorSpaces', formatter: (val) => val.join(', ') },
            { key: 'aspectRatios' },
        ],
        [formatVolume, formatBoolean],
    );

    const resolveLabel = useCallback(
        (key: keyof CollectionTechnicalDetails) => t(`technicalDetails.${key}`),
        [t],
    );

    return (
        <SmartMetadataCard
            title={t('technicalInformation')}
            resolveLabel={resolveLabel}
            isLoading={isLoading}
            source={metadata}
            config={config}
        />
    );
};
